module.exports = __webpack_public_path__ + "media/images/official/bnr_plancheck_sp-d0f66d56847f9fe484f1ab1799556282.jpg";